// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.brew_sample_status_enum */
var BrewSampleStatusEnum;
(function (BrewSampleStatusEnum) {
    BrewSampleStatusEnum["PLANNED"] = "PLANNED";
    BrewSampleStatusEnum["TAKEN"] = "TAKEN";
    BrewSampleStatusEnum["MISSED"] = "MISSED";
    BrewSampleStatusEnum["CANCELLED"] = "CANCELLED";
    BrewSampleStatusEnum["ANALYZING"] = "ANALYZING";
})(BrewSampleStatusEnum || (BrewSampleStatusEnum = {}));
;
export default BrewSampleStatusEnum;
/** Zod schema for brew_sample_status_enum */
export const brewSampleStatusEnum = z.nativeEnum(BrewSampleStatusEnum);
//# sourceMappingURL=BrewSampleStatusEnum.js.map